import script from "./teams.vue?vue&type=script&setup=true&lang=js"
export * from "./teams.vue?vue&type=script&setup=true&lang=js"

import "./teams.vue?vue&type=style&index=0&id=60ad6b4b&lang=less&scoped=true"

import exportComponent from "E:\\zhengbo-supplychain\\web-supplychain\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60ad6b4b"]])

export default __exports__